import React, { Suspense } from 'react';
import { Outlet, Navigate, createRootRoute } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import CacheBuster from '../CacheBuster';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getUser, selectUser } from 'store/user';
import { message } from 'antd';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <Navigate to="/" />,
});

// {
//   process.env.NODE_ENV === 'development' && (
//     <Suspense>
//       <TanStackRouterDevtools position="bottom-right" />
//     </Suspense>
//   )
// }
function RootComponent() {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);

  React.useEffect(() => {
    if (user == null) {
      dispatch(getUser());
    }
  }, []);

  React.useEffect(() => {
    message.config({
      duration: 3,
      maxCount: 1
    });
  }, []);

  return (
    <CacheBuster>
      {({ loading }) => {
        if (loading) {
          return null;
        }
        return (
          <>
            <Outlet />
          </>
        );
      }}
    </CacheBuster>
  );
}
